import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';

i18n
    .use(resourcesToBackend((language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`)))
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: import.meta.env.DEV,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator'],
            lookupQuerystring: 'lang',
            lookupLocalStorage: 'i18nextLng',
            caches: ['localStorage', 'cookie'],
        },
        supportedLngs: ['en', 'en-GB', 'es', 'fr', 'de', 'zh', 'pt', 'ar', 'hi', 'ja', 'ko', 'ru', 'it', 'vi'],
        // Always return the key from fallback language (English) instead of showing the raw key
        returnNull: false,
        returnEmptyString: false,
        // When a key is missing, return the default value (2nd arg to t()) or the key itself
        parseMissingKeyHandler: (key, defaultValue) => {
            return defaultValue || key;
        },
        // Show missing keys in development
        saveMissing: import.meta.env.DEV,
        missingKeyHandler: (lngs, ns, key, fallbackValue) => {
            if (import.meta.env.DEV) {
                console.error(`🚨 Missing translation key: ${key} in namespace: ${ns}`);
            }
        },
    });

export default i18n;
